/* @license Copyright (c) @kurehajime / source code: https://github.com/kurehajime/colamone_js */
'use strict';
import { Rule } from "./rule";
export class Eval {
    /**
     * 盤面を評価して-10000〜+10000で採点数する。
     * @param  {Object.<number, number>}  wkMap
     * @param  {boolean}  nearwin
     * @param  {Object.<number, Array.<number>>}  evalparam
     * @return {number}
     */
    static evalMap(wkMap, nearwin, evalparam) {
        let ev = 0;
        // 引き分け判定
        if (Rule.isDraw(wkMap)) {
            return 0;
        }
        // 終局判定
        let end = Rule.isEndX(wkMap, nearwin);
        if (end === 1) {
            return +9999999;
        }
        else if (end === -1) {
            return -9999999;
        }
        // 評価
        for (let i = 0; i <= 35; i++) {
            let panel_num = Rule.NUMBERS[i] | 0;
            let cell_p = 0;
            let p = wkMap[panel_num];
            let line;
            // コマの評価値を加算
            if (p > 0) {
                line = 5 - (panel_num % 10);
                cell_p += evalparam[p][line]; // ポジションボーナス
            }
            else if (p < 0) {
                line = (panel_num % 10);
                cell_p += evalparam[-1 * p][line] * -1;
            }
            // 評価値に加算。
            ev += cell_p;
        }
        return (ev | 0);
    }
}
/**
 * 初期評価関数
 * @const
 * @type {Object.<number, Array.<number>>}
 */
Eval.DEFAULT_EVALPARAM = [
    [],
    [1800, 1850, 1900, 1950, 2100, 2800],
    [1800, 1860, 1920, 2100, 2400, 3800],
    [1450, 1520, 1590, 1900, 2350, 4450],
    [1450, 1530, 1610, 2050, 2650, 5450],
    [1350, 1440, 1530, 2100, 2850, 6350],
    [1350, 1450, 1550, 2250, 3150, 7350],
    [1250, 1360, 1470, 2300, 3350, 8250],
    [1250, 1370, 1490, 2450, 4350, 11250] //8
];
